"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserCatalog = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _Avatar = require("../Avatar");

var _data = require("../../../global-files/data");

var _UserOption = require("../UserOption");

var _customHooks = require("../../../global-files/customHooks");

var _jsxRuntime = require("react/jsx-runtime");

var UserCatalog = function UserCatalog(_ref) {
  var datasheet = _ref.datasheet,
      description = _ref.description,
      images = _ref.images,
      auditor = _ref.auditor,
      _ref$auditors = _ref.auditors,
      auditors = _ref$auditors === void 0 ? [] : _ref$auditors,
      _ref$textSpecialists = _ref.textSpecialists,
      textSpecialists = _ref$textSpecialists === void 0 ? [] : _ref$textSpecialists,
      _ref$imagesSpecialist = _ref.imagesSpecialists,
      imagesSpecialists = _ref$imagesSpecialist === void 0 ? [] : _ref$imagesSpecialist,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "list-modal" : _ref$id,
      onAssign = _ref.onAssign,
      product = _ref.product;

  var _useCloseModal = (0, _customHooks.useCloseModal)(id),
      _useCloseModal2 = (0, _slicedToArray2.default)(_useCloseModal, 2),
      showList = _useCloseModal2[0],
      setShowList = _useCloseModal2[1];

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    id: id,
    onClick: function onClick(e) {
      if (!e.target.closest("#".concat(id, " .users-assigned-list"))) setShowList(!showList);
    },
    children: [datasheet && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Avatar.Avatar, {
      image: (0, _data.getProfilePicture)(datasheet, 26, 26),
      altText: "datasheet specialist",
      imageType: "medium-image"
    }), description && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Avatar.Avatar, {
      image: (0, _data.getProfilePicture)(description, 26, 26),
      altText: "description specialist",
      imageType: "medium-image"
    }), images && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Avatar.Avatar, {
      image: (0, _data.getProfilePicture)(images, 26, 26),
      altText: "images specialist",
      imageType: "medium-image"
    }), auditor && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Avatar.Avatar, {
      image: (0, _data.getProfilePicture)(auditor, 26, 26),
      altText: "auditor",
      imageType: "medium-image"
    }), showList && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "users-assigned-list",
      children: [product.datasheet_status !== "NS" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_UserOption.UserOption, {
        onAssign: onAssign,
        product: product,
        userId: datasheet,
        usersArray: textSpecialists,
        id: id + "-datasheet",
        index: "datasheet"
      }), product.description_status !== "NS" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_UserOption.UserOption, {
        onAssign: onAssign,
        product: product,
        userId: description,
        usersArray: textSpecialists,
        id: id + "-description",
        index: "description"
      }), product.images_status !== "NS" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_UserOption.UserOption, {
        onAssign: onAssign,
        product: product,
        userId: images,
        usersArray: imagesSpecialists,
        id: id + "-images",
        index: "image"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_UserOption.UserOption, {
        onAssign: onAssign,
        product: product,
        userId: auditor,
        usersArray: auditors,
        id: id + "-auditor",
        index: "auditor"
      })]
    })]
  });
};

exports.UserCatalog = UserCatalog;